import { render, staticRenderFns } from "./showClassList1.vue?vue&type=template&id=17087076&"
import script from "./showClassList1.vue?vue&type=script&lang=js&"
export * from "./showClassList1.vue?vue&type=script&lang=js&"
import style0 from "./showClassList1.vue?vue&type=style&index=0&id=17087076&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports